import { useEffect } from "react";
import { matchPath, useLocation } from "react-router-dom";
import { gameDefinitions } from "./gameDefinitons";
import { recordGameVisit } from "./gamesApi";

import { visitSessionId } from "../stats/visitSession";

export function useGameVisit() {
  const { pathname } = useLocation();
  useEffect(() => {
    const name = matchPath("/games/:name", pathname)?.params.name;
    if (!name || !gameDefinitions.some((game) => game.name === name)) return;
    // Keep the request alive during navigation. The server deduplicates
    // refreshes, repeated navigation and development effect remounts.
    recordGameVisit(name, visitSessionId()).catch(() => {});
  }, [pathname]);
}
